/* bigOne: "Uz augšu" poga. Pašpietiekama — injektē pogu un stilus, rāda pēc noritināšanas. */
(function () {
  if (window.__boBackToTop) return;
  window.__boBackToTop = true;

  function init() {
    if (document.getElementById('bo-back-to-top')) return;
    // Ja tēmas native "back-to-top" ir ieslēgts, neko nepievienojam (nedublējam).
    if (document.querySelector('back-to-top')) return;

    var css =
      '#bo-back-to-top{position:fixed;right:16px;bottom:16px;z-index:9998;width:44px;height:44px;padding:0;border:none;border-radius:50%;background:#1d349a;color:#fff;cursor:pointer;opacity:0;visibility:hidden;transform:translateY(8px);transition:opacity .25s ease,visibility .25s ease,transform .25s ease;box-shadow:0 2px 10px rgba(0,0,0,.2);display:flex;align-items:center;justify-content:center}' +
      '#bo-back-to-top.is-visible{opacity:1;visibility:visible;transform:translateY(0)}' +
      '#bo-back-to-top:hover{background:#2f58cb}' +
      '#bo-back-to-top:focus-visible{outline:2px solid #2f58cb;outline-offset:2px}' +
      '#bo-back-to-top svg{width:20px;height:20px;display:block}' +
      '@media print{#bo-back-to-top{display:none}}';
    var style = document.createElement('style');
    style.textContent = css;
    document.head.appendChild(style);

    var btn = document.createElement('button');
    btn.id = 'bo-back-to-top';
    btn.type = 'button';
    btn.setAttribute('aria-label', (window.boT&&boT.up||'Uz augšu'));
    btn.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M5 12l7-7 7 7"/></svg>';
    btn.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    document.body.appendChild(btn);

    var toggle = function () {
      if ((window.pageYOffset || document.documentElement.scrollTop) > 400) {
        btn.classList.add('is-visible');
      } else {
        btn.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', toggle, { passive: true });
    toggle();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

/* bigOne: Piegādes laiks katrai groza precei (grozs drēbē UN groza lapā). 8 dienas / lietotai tehnikai 5. */
(function(){
  var NORMAL=8, USED=5, MATCH='lietot', cache={};
  function svg(){ return "<svg viewBox='0 0 24 24' width='16' height='16' fill='none' stroke='#1d349a' stroke-width='1.8' stroke-linecap='round' stroke-linejoin='round' style='flex-shrink:0'><path d='M1 3h13v11H1z'/><path d='M14 7h4l3 3v4h-7z'/><circle cx='5' cy='18' r='2'/><circle cx='18' cy='18' r='2'/></svg>"; }
  function handleOf(el){
    var h = el.getAttribute('data-handle');
    if(h) return h;
    var a = el.querySelector('a[href*="/products/"]');
    if(a){
      var m = (a.getAttribute('href')||'').match(/\/products\/([^\/?#]+)/);
      if(m) return decodeURIComponent(m[1]);
    }
    return null;
  }
  function inject(el, days){
    if(el.querySelector('.bo-cart-delivery')) return;
    var d = document.createElement('div');
    d.className='bo-cart-delivery';
    d.style.cssText='display:flex;align-items:center;gap:6px;margin-top:4px;color:#1d349a;font-size:12.5px;line-height:1.3';
    d.innerHTML = svg() + "<span>" + (window.boT&&boT.deliv_days||"Piegādes laiks: līdz {n} darba dienām").replace("{n}", days) + "</span>";
    var title = el.querySelector('.cart-item__title');
    if(title && title.parentNode){
      title.parentNode.insertBefore(d, title.nextSibling);
    } else {
      (el.querySelector('.cart-item__details') || el.querySelector('.cart-item__product--info') || el).appendChild(d);
    }
  }
  function daysFor(tags){
    if(tags){ for(var i=0;i<tags.length;i++){ if(String(tags[i]).toLowerCase().indexOf(MATCH)>-1) return USED; } }
    return NORMAL;
  }
  function process(el){
    if(el.getAttribute('data-bo-delivery')) return;
    var h = handleOf(el);
    if(!h) return;
    el.setAttribute('data-bo-delivery','1');
    if(cache[h]!==undefined){ inject(el, cache[h]); return; }
    fetch('/products/'+h+'.js').then(function(r){ return r.ok?r.json():null; }).then(function(p){ var d=daysFor(p&&p.tags); cache[h]=d; inject(el,d); }).catch(function(){ cache[h]=NORMAL; inject(el,NORMAL); });
  }
  function scan(){ var items=document.querySelectorAll('.cart-item'); for(var i=0;i<items.length;i++) process(items[i]); }
  function init(){ scan(); try{ new MutationObserver(function(){ scan(); }).observe(document.body,{childList:true,subtree:true}); }catch(e){} }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
